<template>
  <div class="notfound__container">
    <not-found></not-found>
  </div>
</template>

<script>
import NotFound from '@/components/Error/NotFound.vue'

export default {
  components: {
    NotFound,
  },
}
</script>

<style scoped>
.notfound__container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}
</style>
